import { useEffect } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { legalDocuments } from "../data/legalContent";
import Breadcrumbs from "./Breadcrumbs";

export default function LegalPage({ type = "privacy" }) {
  const legalDoc = legalDocuments[type] || legalDocuments.privacy;

  useEffect(() => {
    window.document.title = `Cullath ${legalDoc.title} | Cullath`;
      const description =
    "Read the Cullath Terms & Conditions governing the use of our connected workplace platform, website, applications, and related services.";

    window.scrollTo({ top: 0, behavior: "auto" });
  }, [legalDoc.title]);
  useEffect(() => {
  const schemas = [];

  if (type === "terms") {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": "https://cullath.com/terms-and-conditions/#breadcrumb",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cullath.com/" },
        { "@type": "ListItem", "position": 2, "name": "Terms & Conditions", "item": "https://cullath.com/terms-and-conditions" }
      ]
    });
    schemas.push({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://cullath.com/terms-and-conditions/#webpage",
      "url": "https://cullath.com/terms-and-conditions",
      "name": "Cullath Terms & Conditions | Terms of Use",
      "description": "Read the Cullath Terms & Conditions governing the use of our connected workplace platform, website, applications, and related services.",
      "isPartOf": { "@id": "https://cullath.com/#website" },
      "about": { "@id": "https://cullath.com/#organization" },
      "inLanguage": "en-US"
    });
  }

  if (type === "privacy") {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": "https://cullath.com/privacy-policy/#breadcrumb",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cullath.com/" },
        { "@type": "ListItem", "position": 2, "name": "Privacy Policy", "item": "https://cullath.com/privacy-policy" }
      ]
    });
    schemas.push({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://cullath.com/privacy-policy/#webpage",
      "url": "https://cullath.com/privacy-policy",
      "name": "Cullath Privacy Policy",
      "description": "Read the Cullath Privacy Policy explaining how we collect, use, store, and protect your personal information across our connected workplace platform.",
      "isPartOf": { "@id": "https://cullath.com/#website" },
      "about": { "@id": "https://cullath.com/#organization" },
      "inLanguage": "en-US"
    });
  }

  const scripts = schemas.map((schema) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(schema);
    document.head.appendChild(s);
    return s;
  });

  return () => scripts.forEach((s) => s.remove());
}, [type]);

  return (
    <div className="legal-page">
      <SiteHeader isHeroPage />

      <main className="legal-main">
        <header className="legal-title-block">
          <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: legalDoc.title }]} />
          <p>CULLATH LEGAL</p>
          <h1>{legalDoc.title}</h1>
          <div className="legal-dates">
            <span>{legalDoc.effective}</span>

            <span>{legalDoc.updated}</span>
          </div>
        </header>

        <div className="legal-layout">
          <aside className="legal-toc" aria-label="Table of contents">
            <div className="legal-toc-card">
              <h2>Table of contents</h2>
              <nav>
                {legalDoc.sections.map((section) => (
                  <a href={`#${section.id}`} key={section.id}>
                    <span>{String(section.number).padStart(2, "0")}</span>
                    {section.title}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          <article className="legal-document">
            {legalDoc.sections.map((section) => (
              <section className="legal-section" id={section.id} key={section.id}>
                <h2><span>{String(section.number).padStart(2, "0")}</span>{section.title}</h2>
                <div className="legal-section-body">
                  {section.blocks.map((block, index) => {
                    if (block.type === "subheading") return <h3 key={index}>{block.text}</h3>;
                    if (block.type === "list") {
                      return (
                        <ul key={index}>
                          {block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
                        </ul>
                      );
                    }
                    // paragraph
                    if (block.content) {
                      return (
                        <p key={index}>
                          {block.content.map((node, i) =>
                            node.type === "link" ? (
                              <a key={i} href={node.href} target="_blank" rel="noopener noreferrer" className="legal-link">
                                {node.value}
                              </a>
                            ) : (
                              <span key={i}>{node.value}</span>
                            )
                          )}
                        </p>
                      );
                    }
                    return <p key={index}>{block.text}</p>;
                  })}
                </div>
              </section>
            ))}
          </article>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}